let sharedAudioContext = null;

const getAudioContext = () => {
  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  if (!AudioCtx) return null;

  if (!sharedAudioContext || sharedAudioContext.state === "closed") {
    sharedAudioContext = new AudioCtx();
  }

  return sharedAudioContext;
};

const playTone = (context, frequency, startAt, duration, volume = 0.12) => {
  const oscillator = context.createOscillator();
  const gain = context.createGain();

  oscillator.type = "sine";
  oscillator.frequency.value = frequency;
  oscillator.connect(gain);
  gain.connect(context.destination);

  gain.gain.setValueAtTime(0.0001, startAt);
  gain.gain.exponentialRampToValueAtTime(volume, startAt + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, startAt + duration);

  oscillator.start(startAt);
  oscillator.stop(startAt + duration + 0.02);
};

/**
 * Call on Send (user gesture) so the chime can play when the answer arrives later,
 * whether the chat panel is open or closed.
 */
export const primeAdvisorReadySound = () => {
  try {
    const context = getAudioContext();
    if (!context) return;

    if (context.state === "suspended") {
      void context.resume();
    }

    const buffer = context.createBuffer(1, 1, context.sampleRate);
    const source = context.createBufferSource();
    source.buffer = buffer;
    source.connect(context.destination);
    source.start(0);
  } catch {
    // Audio is optional.
  }
};

/**
 * Short two-note chime when the business advisor finishes an answer.
 */
export const playAdvisorReadySound = async () => {
  try {
    const context = getAudioContext();
    if (!context) return;

    if (context.state === "suspended") {
      await context.resume();
    }

    const start = context.currentTime;
    playTone(context, 523.25, start, 0.14);
    playTone(context, 659.25, start + 0.16, 0.22);
  } catch {
    // Audio is optional — ignore if blocked by the browser.
  }
};
